<template>
  <div class="flow-content">
    <transition
      appear
      name="fade"
    >
      <div
        class="container"
        v-if="currentStep">
        <Button
          theme="transparent"
          arrow="begin"
          shape="minimal"
          class="back"
        >
          <router-link to="/">
            <span class="slot">Terug naar begin</span>
          </router-link>
        </Button>

        <div class="row">
          <div class="entry">
            <h1
              v-if="currentStep.title"
              class="title"
            >
              {{ currentStep.title }}
            </h1>

            <div
              v-if="currentStep.body"
              class="content"
              v-html="currentStep.body"
            ></div>

            <ul
              class="list"
              v-if="currentStep.buttons"
            >
              <li
                v-for="(button, index) in currentStep.buttons"
                :key="index"
                class="item"
              >
                <template v-if="button.modal">
                  <Button theme="yellow">
                    <span @click="showModal = true">
                      {{ button.text }}
                    </span>
                  </Button>
                  <Modal
                    v-if="showModal"
                    @close="showModal = false"
                  >
                    <img
                      v-if="button.modalImage"
                      draggable="false"
                      slot="image"
                      alt=""
                      :src="require('@/assets/images/flowchart/' + button.modalImage)"
                    />

                    <h2
                      v-if="button.modalTitle"
                      slot="title">{{ button.modalTitle }}</h2>

                    <div slot="body" v-html="button.modalText"></div>

                    <ul
                      class="list"
                      slot="buttons"
                    >
                      <li
                        v-for="(item, j) in button.links"
                        :key="j"
                        class="item"
                      >
                        <Button theme="yellow">
                          <a
                            :href="item.href"
                            target="_blank"
                            class="slot"
                          >
                            {{ item.text }}
                          </a>
                        </Button>
                      </li>

                      <li
                        v-if="button.route"
                        class="item"
                      >
                        <Button theme="yellow">
                          <router-link class="slot" :to="button.route">
                            {{ button.text }}
                          </router-link>
                        </Button>
                      </li>
                    </ul>
                  </Modal>
                </template>
                <template v-else>
                  <Button theme="yellow">
                    <router-link class="slot" :to="button.route">
                      {{ button.text }}
                    </router-link>
                  </Button>
                </template>
              </li>
            </ul>
          </div>

          <div class="media">
            <figure
              v-if="currentStep.image"
              class="figure"
            >
              <img
                draggable="false"
                alt=""
                class="image"
                :src="require('@/assets/images/flowchart/' + currentStep.image)"
              />
            </figure>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Button from '@/components/Button'
import Modal from '@/components/Modal'

export default {
  name: 'FlowContent',
  props: {
    type: {
      type: String,
      required: true
    },
    json: {
      type: Array,
      required: true
    }
  },
  components: {
    Button,
    Modal
  },
  data () {
    return {
      currentStep: {},
      showModal: false
    }
  },
  methods: {
    getCurrent (path) {
      return this.json.filter(i => i.route === path)
    },
    setCurrent (path) {
      this.currentStep = this.getCurrent(path)[0]
    }
  },
  created () {
    this.setCurrent(this.$route.fullPath)
  }
}
</script>

<style lang="scss" scoped>
  .flow-content {
    background-color: $c-yellow2;
    position: relative;

    &:after {
      content: "";
      left: 0;
      right: 0;
      top: 100%;
      height: 999px;
      background-color: inherit;
      position: absolute;
    }
  }
  .container {
    @extend %container;
    padding-top: 70px;
    padding-bottom: 70px;

    @media (max-width: 1380px) {
      padding-top: 46px;
      padding-bottom: 46px;
    }
  }
  .back {
    margin-bottom: 24px;

    @media (min-width: 1381px) {
      display: none;
    }
  }
  .row {
    @extend %row;
  }
  .media {
    @extend %col-md-6;
    @extend %col-md-pull-6;

    @media (max-width: 991px) {
      margin-top: 20px;
    }
  }
  .entry {
    @extend %col-md-6;
    @extend %col-md-push-6;
  }

  .title {
    margin-top: 0;
    margin-bottom: 0.71em;
  }
  .list {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
  .item {
    margin: 0;
  }
  .item + .item {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Flow/components/FlowContent.vue